import { CircularProgress, Typography } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import {
  Button,
  useDataProvider,
  useListContext,
  useRecordSelection,
} from "react-admin";
import classes from "./SelectAllHandler.module.css";

interface Props {
  resource: string;
  filter?: any;
}

export const SelectAllHandler = ({ resource, filter = {} }: Props) => {
  const [ids, { select }] = useRecordSelection(resource);
  const { perPage, total } = useListContext();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState<boolean>(false);
  const [showSelectAll, setShowSelectAll] = useState<boolean>(false);

  const handleSelectAll = useCallback(() => {
    setLoading(true);
    dataProvider
      .getList(resource, {
        pagination: { perPage: total, page: 1 },
        filter,
        sort: { field: "id", order: "asc" },
      })
      .then((result) => {
        select(result.data.map((x) => x.id));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataProvider, resource, filter, select, total]);

  useEffect(() => {
    setShowSelectAll(ids.length === perPage);
  }, [ids, perPage]);
  return (
    <div className={classes.header}>
      <Typography variant="body2">{ids.length} item(s) selected</Typography>
      <>{loading ? <CircularProgress size="22.75px" /> : null}</>
      <>
        {showSelectAll && !loading ? (
          <div>
            <Button
              label={`Click to select all ${total} items`}
              onClick={handleSelectAll}
            ></Button>
          </div>
        ) : null}
      </>
    </div>
  );
};
